import type { TLngLat } from 'App/Map/types'
import type { TBlockId, TPoint } from 'stores/fieldAssetStore/helperTypes'
import { lngLatStringToLngLatObject } from 'utils/lngLatStringToLngLatObject'
import { sortByClosestPoints } from 'utils/sortByClosestPoints'

export const getClosestLngLatBasedFieldAssetInPropertyForAPoint = ({
  anchorCoordinates,
  fieldAssetValues,
  block,
}: {
  anchorCoordinates: { lng: number; lat: number }
  block?: TBlockId | null
  fieldAssetValues: TPoint[]
}): TLngLat | null => {
  const fieldAssetValuesWithLngLats = fieldAssetValues.filter((f) => !!f?.lngLat)

  if (block) {
    const [closestInBlock] = fieldAssetValuesWithLngLats
      .filter((p) => p?.blockIds?.includes(block))
      .map((p) => {
        return {
          ...lngLatStringToLngLatObject(p.lngLat),
          lngLat: p.lngLat,
        }
      })
      .sort(sortByClosestPoints(anchorCoordinates))

    if (closestInBlock) return closestInBlock.lngLat
  }

  const [closest] = fieldAssetValuesWithLngLats
    .map((f) => {
      return {
        ...lngLatStringToLngLatObject(f.lngLat),
        lngLat: f.lngLat,
      }
    })
    .sort(sortByClosestPoints(anchorCoordinates))

  if (closest) return closest.lngLat

  return null
}
